import { Pressable, Text, View } from "react-native";
import React, { useState } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spV, wp } from "utils/normalizeV2";

import VText from "components/VText";

const SectionName = ({ o, color }) => {
    const [left, setLeft] = useState(0);
    return (
        <View
            style={{
                width: 200,
                position: "absolute",
                top: 50,
                left: -left + wp(20),
                alignSelf: "flex-start",
                marginTop: 10,
            }}
        >
            <VText
                onLayout={(event) => {
                    const { x, y, width, height } = event.nativeEvent.layout;
                    setLeft(width / 2);
                }}
                style={{
                    fontSize: fp(16),
                    alignSelf: "flex-start",
                    color: color,
                }}
            >
                {o?.sectionName}
            </VText>
        </View>
    );
};

const PreferenceSteps = ({ prefQuestions = [], stepNo = 1, setStepNo = () => {} }) => {
    return (
        <View
            style={{
                paddingBottom: spV(70),
            }}
        >
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {prefQuestions?.map((o, idx) => (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        {idx != 0 && (
                            <View
                                style={{
                                    height: hp(3),
                                    width: wp(152),
                                    backgroundColor: idx < stepNo ? "rgba(33, 36, 39, 1)" : "rgba(33, 36, 39, 0.3)",
                                }}
                            />
                        )}
                        <View style={{}}>
                            <Pressable
                                style={{
                                    height: wp(40),
                                    width: wp(40),
                                    borderWidth: 2,
                                    borderColor: idx < stepNo ? "rgba(33, 36, 39, 1)" : "rgba(33, 36, 39, 0.3)",
                                    borderRadius: 100,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: stepNo > idx + 1 ? "rgba(33, 36, 39, 1)" : "transparent",
                                }}
                                onPress={() => setStepNo(idx + 1)}
                                key={idx}
                            >
                                {stepNo > idx + 1 ? (
                                    <Svg
                                        width="17"
                                        height="12"
                                        viewBox="0 0 17 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M16.5 1.20177L5.45887 12L0.5 7.15022L1.7288 5.94845L5.45887 9.59646L15.2712 0L16.5 1.20177Z"
                                            fill="white"
                                        />
                                    </Svg>
                                ) : (
                                    <VText
                                        style={{
                                            fontSize: fp(16),
                                            fontFamily: "LibreBodoni",
                                            color: idx < stepNo ? "rgba(33, 36, 39, 1)" : "rgba(33, 36, 39, 0.3)",
                                        }}
                                        text={`0${idx + 1}`}
                                    />
                                )}
                            </Pressable>
                            <SectionName o={o} color={idx < stepNo ? "rgba(33, 36, 39, 1)" : "rgba(33, 36, 39, 0.3)"} />
                        </View>
                    </View>
                ))}
            </View>
        </View>
    );
};

export default PreferenceSteps;
